import { Exercise as ComponentExercise, ExerciseType } from "@/services/admin/exercises.interfaces";
import { EditorInterface } from "./EditorInterface";
import { ListChecks } from "lucide-react";
import { getExerciseProperty, parseExerciseData } from "./utils";

/**
 * Editor para exercícios de múltipla escolha (versão unificada)
 * Combina as funcionalidades de editors/MultipleChoiceEditor.ts e exerciseComponents/MultipleChoice/CardInfo.ts
 */
export class MultipleChoiceInfo extends EditorInterface {
  /**
   * Retorna as informações para exibir no cartão do exercício de múltipla escolha
   * @param exercise Objeto do exercício
   */
  static GetCardInfo(exercise: ComponentExercise): {
    title: string;
    subtitle: string;
    description?: string;
  } {
    if (!exercise || (exercise.type !== ExerciseType.MultipleChoice && !MultipleChoiceInfo.SupportsExerciseType(exercise.type as unknown as string))) {
      return {
        title: 'Múltipla Escolha',
        subtitle: 'Sem detalhes',
      };
    }

    try {
      console.log("Dados do exercício recebido:", exercise);
      // Usar as funções utilitárias para processar os dados
      const parsedExercise = parseExerciseData(exercise);
      console.log("Dados do exercício após parsing:", parsedExercise);
      
      // Extrair a pergunta e opções usando as funções utilitárias
      const question = getExerciseProperty<string>(parsedExercise, 'question', 'Sem pergunta');
      const options = getExerciseProperty<any[]>(parsedExercise, 'options', []);
      
      // Conta o número de opções
      const optionsCount = options.length;
      
      return {
        title: "Múltipla Escolha",
        subtitle: question.length > 60 ? `${question.substring(0, 60)}...` : question,
        description: `${optionsCount} opções`,
      };
    } catch (error) {
      console.error("Erro ao processar dados do exercício de múltipla escolha:", error, exercise);
      return {
        title: 'Múltipla Escolha',
        subtitle: 'Erro ao processar dados',
      };
    }
  }
  
  /**
   * Retorna o título do tipo de exercício de múltipla escolha
   */
  static getTitle(): string {
    return "Múltipla Escolha";
  }
  
  /**
   * Retorna uma descrição formatada para o exercício de múltipla escolha
   * @param exercise Objeto do exercício
   */
  static getDescription(exercise: ComponentExercise): string {
    if (!exercise) {
      return "Sem detalhes";
    }
    
    try {
      // Usar as funções utilitárias para processar os dados
      const parsedExercise = parseExerciseData(exercise);
      
      // Extrair as opções usando a função utilitária
      const options = getExerciseProperty<any[]>(parsedExercise, 'options', []);
      
      const optionsCount = options.length;
      return optionsCount > 0 ? `${optionsCount} opções` : "Sem detalhes";
    } catch (error) {
      console.error("Erro ao processar dados do exercício:", error, exercise);
      return "Erro ao processar dados";
    }
  }
  
  /**
   * Retorna o ícone para exercícios de múltipla escolha
   */
  static getIcon() {
    return ListChecks;
  }
  
  /**
   * Verifica se o exercício é do tipo de múltipla escolha
   */
  static SupportsExerciseType(type: string): boolean {
    return type === ExerciseType.MultipleChoice;
  }
}